// extracted by mini-css-extract-plugin
export default {"nav":"Sidebar_nav__0xRpt","navHead":"Sidebar_navHead__gbvua","navItem":"Sidebar_navItem__HI8+W"};